import { ComponentF } from "../../ui/ui";
import { LetterSelect } from "./words/LetterSelect";
import { TrashLetterSelect } from "./words/TrashLetterSelect";

export const PromptTypes = {
  trashLettersPrompt: TrashLetterSelect,
  letterSelect: LetterSelect,
} as Record<string, ComponentF<any>>;
